import { createAggregatedClient } from "@smithy/smithy-client";
import { CreateCallAnalyticsCategoryCommand, } from "./commands/CreateCallAnalyticsCategoryCommand";
import { CreateLanguageModelCommand, } from "./commands/CreateLanguageModelCommand";
import { CreateMedicalVocabularyCommand, } from "./commands/CreateMedicalVocabularyCommand";
import { CreateVocabularyCommand, } from "./commands/CreateVocabularyCommand";
import { CreateVocabularyFilterCommand, } from "./commands/CreateVocabularyFilterCommand";
import { DeleteCallAnalyticsCategoryCommand, } from "./commands/DeleteCallAnalyticsCategoryCommand";
import { DeleteCallAnalyticsJobCommand, } from "./commands/DeleteCallAnalyticsJobCommand";
import { DeleteLanguageModelCommand, } from "./commands/DeleteLanguageModelCommand";
import { DeleteMedicalScribeJobCommand, } from "./commands/DeleteMedicalScribeJobCommand";
import { DeleteMedicalTranscriptionJobCommand, } from "./commands/DeleteMedicalTranscriptionJobCommand";
import { DeleteMedicalVocabularyCommand, } from "./commands/DeleteMedicalVocabularyCommand";
import { DeleteTranscriptionJobCommand, } from "./commands/DeleteTranscriptionJobCommand";
import { DeleteVocabularyCommand, } from "./commands/DeleteVocabularyCommand";
import { DeleteVocabularyFilterCommand, } from "./commands/DeleteVocabularyFilterCommand";
import { DescribeLanguageModelCommand, } from "./commands/DescribeLanguageModelCommand";
import { GetCallAnalyticsCategoryCommand, } from "./commands/GetCallAnalyticsCategoryCommand";
import { GetCallAnalyticsJobCommand, } from "./commands/GetCallAnalyticsJobCommand";
import { GetMedicalScribeJobCommand, } from "./commands/GetMedicalScribeJobCommand";
import { GetMedicalTranscriptionJobCommand, } from "./commands/GetMedicalTranscriptionJobCommand";
import { GetMedicalVocabularyCommand, } from "./commands/GetMedicalVocabularyCommand";
import { GetTranscriptionJobCommand, } from "./commands/GetTranscriptionJobCommand";
import { GetVocabularyCommand, } from "./commands/GetVocabularyCommand";
import { GetVocabularyFilterCommand, } from "./commands/GetVocabularyFilterCommand";
import { ListCallAnalyticsCategoriesCommand, } from "./commands/ListCallAnalyticsCategoriesCommand";
import { ListCallAnalyticsJobsCommand, } from "./commands/ListCallAnalyticsJobsCommand";
import { ListLanguageModelsCommand, } from "./commands/ListLanguageModelsCommand";
import { ListMedicalScribeJobsCommand, } from "./commands/ListMedicalScribeJobsCommand";
import { ListMedicalTranscriptionJobsCommand, } from "./commands/ListMedicalTranscriptionJobsCommand";
import { ListMedicalVocabulariesCommand, } from "./commands/ListMedicalVocabulariesCommand";
import { ListTagsForResourceCommand, } from "./commands/ListTagsForResourceCommand";
import { ListTranscriptionJobsCommand, } from "./commands/ListTranscriptionJobsCommand";
import { ListVocabulariesCommand, } from "./commands/ListVocabulariesCommand";
import { ListVocabularyFiltersCommand, } from "./commands/ListVocabularyFiltersCommand";
import { StartCallAnalyticsJobCommand, } from "./commands/StartCallAnalyticsJobCommand";
import { StartMedicalScribeJobCommand, } from "./commands/StartMedicalScribeJobCommand";
import { StartMedicalTranscriptionJobCommand, } from "./commands/StartMedicalTranscriptionJobCommand";
import { StartTranscriptionJobCommand, } from "./commands/StartTranscriptionJobCommand";
import { TagResourceCommand } from "./commands/TagResourceCommand";
import { UntagResourceCommand, } from "./commands/UntagResourceCommand";
import { UpdateCallAnalyticsCategoryCommand, } from "./commands/UpdateCallAnalyticsCategoryCommand";
import { UpdateMedicalVocabularyCommand, } from "./commands/UpdateMedicalVocabularyCommand";
import { UpdateVocabularyCommand, } from "./commands/UpdateVocabularyCommand";
import { UpdateVocabularyFilterCommand, } from "./commands/UpdateVocabularyFilterCommand";
import { TranscribeClient } from "./TranscribeClient";
const commands = {
    CreateCallAnalyticsCategoryCommand,
    CreateLanguageModelCommand,
    CreateMedicalVocabularyCommand,
    CreateVocabularyCommand,
    CreateVocabularyFilterCommand,
    DeleteCallAnalyticsCategoryCommand,
    DeleteCallAnalyticsJobCommand,
    DeleteLanguageModelCommand,
    DeleteMedicalScribeJobCommand,
    DeleteMedicalTranscriptionJobCommand,
    DeleteMedicalVocabularyCommand,
    DeleteTranscriptionJobCommand,
    DeleteVocabularyCommand,
    DeleteVocabularyFilterCommand,
    DescribeLanguageModelCommand,
    GetCallAnalyticsCategoryCommand,
    GetCallAnalyticsJobCommand,
    GetMedicalScribeJobCommand,
    GetMedicalTranscriptionJobCommand,
    GetMedicalVocabularyCommand,
    GetTranscriptionJobCommand,
    GetVocabularyCommand,
    GetVocabularyFilterCommand,
    ListCallAnalyticsCategoriesCommand,
    ListCallAnalyticsJobsCommand,
    ListLanguageModelsCommand,
    ListMedicalScribeJobsCommand,
    ListMedicalTranscriptionJobsCommand,
    ListMedicalVocabulariesCommand,
    ListTagsForResourceCommand,
    ListTranscriptionJobsCommand,
    ListVocabulariesCommand,
    ListVocabularyFiltersCommand,
    StartCallAnalyticsJobCommand,
    StartMedicalScribeJobCommand,
    StartMedicalTranscriptionJobCommand,
    StartTranscriptionJobCommand,
    TagResourceCommand,
    UntagResourceCommand,
    UpdateCallAnalyticsCategoryCommand,
    UpdateMedicalVocabularyCommand,
    UpdateVocabularyCommand,
    UpdateVocabularyFilterCommand,
};
export class Transcribe extends TranscribeClient {
}
createAggregatedClient(commands, Transcribe);
